var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFClothes3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 161,
    viewBox: "0 0 129 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2496 153.145C8.02804 152.237 5.19059 146.975 5.81345 141.441L17.3708 42.278C18.1321 35.7458 22.8381 31.3003 27.7517 32.4797C32.7346 33.5684 35.9873 39.7377 35.0876 46.1792L21.2464 144.888C20.4851 150.423 16.4712 154.052 12.2496 153.145Z",
    fill: "#FFA39B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6373 159.767L0 154.324L2.69903 133.094L27.4056 138.538L24.6373 159.767Z",
    fill: "#B9CBD7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.74418 149.425C5.74418 150.06 5.32895 150.604 4.8445 150.604C4.36006 150.604 3.94482 150.06 3.94482 149.425C3.94482 148.79 4.36006 148.336 4.8445 148.336C5.32895 148.336 5.74418 148.79 5.74418 149.425Z",
    fill: "#373330"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6202 23.2257C38.8246 25.2217 44.8455 37.016 42.7693 48.901L26.5751 143.255L2.35303 137.903L10.7269 41.8244C11.765 29.6672 20.4158 21.139 29.6202 23.2257V23.2257Z",
    fill: "#D3DDE6"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M107.754 145.342L93.9126 46.6329C93.0129 40.1914 96.2656 34.022 101.248 32.9333C106.162 31.8446 110.868 36.2902 111.629 42.7317L123.187 141.985C123.81 147.52 120.972 152.691 116.751 153.598C112.529 154.596 108.515 150.876 107.754 145.342Z",
    fill: "#FFA39B"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M101.594 139.082L126.301 133.548L129 154.778L104.363 160.312L101.594 139.082Z",
    fill: "#B9CBD7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M125.055 149.425C125.055 150.06 124.64 150.604 124.156 150.604C123.671 150.604 123.256 150.06 123.256 149.425C123.256 148.79 123.671 148.336 124.156 148.336C124.64 148.336 125.055 148.79 125.055 149.425Z",
    fill: "#373330"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M118.273 42.278L126.647 138.356L102.425 143.709L86.2306 49.4453C84.1544 37.4695 90.1753 25.6752 99.3797 23.6793C108.584 21.5926 117.235 30.1208 118.273 42.278V42.278Z",
    fill: "#D3DDE6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4888 8.52808H63.3922H75.2956C78.8251 8.52808 105.677 23.77 105.677 23.8607L104.847 141.985H23.1835L22.4915 23.6792C22.4915 23.6792 47.9593 8.52808 51.4888 8.52808Z",
    fill: "#E0E8EE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M96.4037 56.7034H76.9568V49.7176H96.4037V56.7034Z",
    fill: "#FCFCFC"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2717 13.7903H68.5142V27.3991H58.2717V13.7903Z",
    fill: "#69224B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M58.2717 27.3991H68.5142V142.802L63.1853 149.425L58.2717 142.802V27.3991Z",
    fill: "#69224B"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63.3926 14.2439L57.5793 29.4857L45.6067 12.4294L46.9908 1.08868L63.3926 14.2439Z",
    fill: "#D3DDE6"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1022 0L80.4863 11.4314L68.7213 29.4858L63.1848 13.9717L79.1022 0Z",
    fill: "#D3DDE6"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFClothes3);
export default __webpack_public_path__ + "static/media/f-clothes-3.26f3b5a5c3a6ea2b00cb25e25d249949.svg";
export { ForwardRef as ReactComponent };